export const placeholderImg = 'https://bblockswp.com/wp-content/demo/img/green-hill.jpg';